/**
 * @author        esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   selectFloorplanFromUrlParam
 */

import type { FloorplanListing, NormalFloorplanListingData } from '@zcode/state-type'

import type { getUrlParams } from '../../../../utils/urls/getUrlParams'

const paramToInt = (param: ReturnType<typeof getUrlParams>[string]) => {
  if (typeof param === 'undefined') {
    return Number.NaN
  }
  return Number.parseInt(Array.isArray(param) ? param[0] : param)
}

export const selectFloorplanFromUrlParams = (
  urlParams: ReturnType<typeof getUrlParams>,
  floorplans: ReadonlyArray<FloorplanListing<NormalFloorplanListingData>> | undefined
): Array<FloorplanListing<NormalFloorplanListingData>> | undefined => {
  const listingId = paramToInt(urlParams.listingId)
  const bathrooms = paramToInt(urlParams.bathrooms)
  const bedrooms = paramToInt(urlParams.bedrooms)
  const hasValidListingId = floorplans?.some((fp) => {
    return fp.isActive && fp.listingId === listingId
  })
  const hasValidBedroom = floorplans?.some((fp) => {
    return fp.isActive && fp.listingId === listingId && fp.bathrooms === bathrooms
  })
  if (hasValidListingId && !isNaN(listingId)) {
    return floorplans?.filter((fp) => {
      return fp.isActive && fp.listingId === listingId
    })
  }
  if (!hasValidListingId && !isNaN(bedrooms)) {
    return floorplans?.filter((fp) => {
      return fp.isActive && fp.bedrooms === bedrooms
    })
  }
  if (!hasValidListingId && !hasValidBedroom && !isNaN(bathrooms)) {
    return floorplans?.filter((fp) => {
      return fp.isActive && fp.bathrooms === bathrooms
    })
  }

  return []
}
